module.exports = __webpack_public_path__ + "media/Misc_Showreel_Low.0d2b1a20.mp4";